export default __webpack_public_path__ + "static/media/mongo.932fe1fd.svg";